<template>
	<div class="mobile-header">
		<div class="burger" v-html="require('@/assets/icons/burger.svg')" @click="toggleMenu"/>

		<transition name="sidemenu">
			<div class="sidemenu" v-if="open">
				<div class="close" v-html="require('@/assets/icons/close.svg')" @click="toggleMenu"/>
				<vNav/>
			</div>
		</transition>

		<transition name="overlay">
			<div class="overlay" v-if="open" @click="toggleMenu"/>
		</transition>

		<router-link class="logo" :to="{name: 'index'}">
			<img src="@/assets/images/logo.png"/>
		</router-link>
	</div>
</template>

<script>
import vNav from "./nav.vue";

export default {
	components: {vNav},
	data() {
		return {
			open: false
		}
	},
	methods: {
		toggleMenu() {
			this.open = !this.open;
		}
	},
	watch: {
		$route() {
			this.open = false;
		}
	}
};
</script>

<style lang="scss" scoped>
.mobile-header {
	z-index: 1;
	background-color: $white1;
	position: fixed;
	left: 0;
	right: 0;
	top: 0;
	height: $headerSmall;
	padding: 0 em(27);
	border-bottom: 1px solid #E2E2E2;
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;

	.burger {
		position: relative;
		top: 2px;
	}

	.sidemenu {
		position: fixed;
		top: 0;
		left: 0;
		background-color: #F1F1F1;
		height: 100vh;
		width: 100%;
		max-width: 225px;
		padding: em(22) em(28);

		&-enter-active, &-leave-active {
			transition: transform .25s;
		}

		&-enter, &-leave-to {
			transform: translateX(-100%);
		}

		.close {
			display: inline-block;
		}

		/deep/ {
			.nav {
				margin-top: 107px;

				.item {
					display: flex;
					align-items: center;
					margin-bottom: 2em;

					.icon {
						display: inline-flex;
						margin-right: 1em;

						svg {
							$s: 28px;
							width: $s;
							height: $s;
						}
					}

					&.router-link-exact-active .icon svg path {
						fill: #D5D6D8;
					}

					.text {
						font-size: 17px;
						line-height: 17px;

					}
				}
			}
		}
	}

	.overlay {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100vh;
		background-color: #22313A;
		opacity: 0.9;
		z-index: -1;

		&-enter-active, &-leave-active {
			transition: opacity .25s;
		}

		&-enter, &-leave-to {
			opacity: 0;
		}
	}

	.logo {
		width: em(85);
		flex-shrink: 0;

		img {
			display: block;
		}
	}
}
</style>
